import { NavigateNext } from "@mui/icons-material";
import { IconButton, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { theme } from "src/assets/theme";
import WhiteCard from "src/shared/components/WhiteCard";

const ManageCard = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const component = "subscriptions.manage";

  return (
    <WhiteCard direction="row" justifyContent="space-between">
      <Stack gap={0.5}>
        <Typography variant="subtitle1" fontWeight={500}>
          {t(`${component}.card-title`, "Discontinued plan")}
        </Typography>
        <Typography color={theme.palette.primary.main} fontWeight={600}>
          {t(`${component}.card-text`, "Turn off auto-renewal")}
        </Typography>
      </Stack>
      <IconButton
        size="small"
        sx={{ color: theme.palette.primary.main }}
        onClick={() => navigate(pathname.replace(`manage`, `cancel`))}
      >
        <NavigateNext fontSize="large" />
      </IconButton>
    </WhiteCard>
  );
};

export default ManageCard;
